import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/render/project/src/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/not-found.module.scss");
;
import(/* webpackMode: "eager" */ "/opt/render/project/src/src/shared/lib/staticImageLoader.ts");
